$(document).ready(function() { 
// Watch More Link click handlers
    const $banner = $('.video-banner');
    const $modal = $('#modal');
    const $closeIcon = $('.close');
    const $watchMoreLink = $('.watch-more');
    var youTubeUrl = $('.video-container iframe').attr('src');

    $watchMoreLink.click(function(e) {
        $banner.fadeIn(200);
        $modal.fadeIn(200);
        e.preventDefault();
        $('body').addClass('overlay-active');
       $(this).closest('.video-container iframe').attr('src', youTubeUrl);
    });
    $closeIcon.click(function () {
        $banner.fadeOut(200);
        $modal.fadeOut(200);
       $('body').removeClass('overlay-active');
       $(this).closest('.video-container iframe').attr('src', '');
    });
    // for escape key
    $(document).on('keyup',function(e) {
        if (e.key === "Escape") {
           $banner.fadeOut(200);
           $modal.fadeOut(200);
        }
    });
    // click outside of the banner, close it
    $modal.on('click', function(e){
        $banner.fadeOut(200);
        $modal.fadeOut(200);
       $('body').removeClass('overlay-active');
    });
});